import { render, staticRenderFns } from "./StatisticsRenderer.vue?vue&type=template&id=41218044&scoped=true&"
import script from "./StatisticsRenderer.vue?vue&type=script&lang=ts&"
export * from "./StatisticsRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsRenderer.vue?vue&type=style&index=0&id=41218044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41218044",
  null
  
)

export default component.exports